import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase-config";


// returns an arrays
export const getCoursesWithModification = async () => {
    const coursesCollection = collection(db, "courses");
    const coursesSnapshot = await getDocs(coursesCollection);

    const coursesList = coursesSnapshot.docs.map(doc => {
        const data = doc.data();
        
        // Debug logging
        console.log('Course data:', {
            id: doc.id,
            coursePrice: data.coursePrice,
            courseName: data.courseName,
            rawData: data
        });
        
        // Ensure price is properly formatted
        const originalPrice = data.coursePrice || data.packagePrice || "1800";
        const numericPrice = parseFloat(originalPrice);
        const formattedPrice = !isNaN(numericPrice) ? `₹${numericPrice}` : "₹1800";
        const crossedPrice = !isNaN(numericPrice) ? `₹${(numericPrice * 2)}` : "₹3600";

        return {
            id: doc.id,
            packageImage: data.courseImage || data.packageImage,
            packageTitle: data.courseName || data.packageName || "All Courses",
            packageDetails: [`${data.courseDuration || data.packageDuration || '6'} months`, "3 classes/week", "Recording"],
            points: ["Free Doubt Session", "Live Q&A Support", "Affiliate Ritual Certificate"],
            packagePrice: formattedPrice,
            packagePriceCross: crossedPrice,
            ...data,
        };
    });
    return coursesList || [];
}
